import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { COMPARE_PRICE, PRICE } from '../data/content';
const recap = ['6 bind', '5 bonusser', '240 sider', '3 hold'];
const reassurances = ['Øjeblikkelig digital adgang', 'PDF-filer til print', '7 dages tilfredshedsgaranti'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15c2f5bc2arsy">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbahgd3iug1d" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1t2ydkrb0wl96">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t2ex7f10u4x9">
          Dine vandgymtimer kan være <em className="text-red-700" data-id="element-118" data-mp="223mh2s2sj37t">klar allerede i dag.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="223wbcruvbwjb">
          I stedet for at lede efter øvelser, skrive hver holdtime selv og bruge søndagsaftenerne
          på forberedelse har du en organiseret vandgympakke til hele sæsonen. Mere tid til det,
          der virkelig betyder noget:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="x41wm2yfl9ab">
          Dine deltagere. Dit hold. Dit liv uden for svømmehallen.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="120ilx0hd9toz">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1b31k37a7ji4w">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b1qgp8kocceb">
          <s className="mr-3 align-middle text-3xl text-slate-900/40 sm:text-4xl" data-id="element-124" data-mp="1fwcvllpysn35"><span className="sr-only" data-id="element-125" data-mp="1ks1q3an4ndsl">Før </span>{COMPARE_PRICE}</s>
          {PRICE}
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-126" data-mp="1ptqzklupbjek">Engangsbetaling – intet abonnement.</p>

        <div className="mt-8 flex justify-center" data-id="element-127" data-mp="1tv2qqvt84cov">
          <CtaButton className="w-full sm:w-auto" data-id="element-128" data-mp="3quov8ozk0jm8" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-129" data-mp="3qv73yl3ekqb1">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-130" data-mp="3hl5z8jysgd5">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-131" data-mp="3j604x2d9xah" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}